const AdminIcon = ({ iconStyle }) => {
  return (
    <svg
      className={iconStyle}
      xmlns='http://www.w3.org/2000/svg'
      x='0'
      y='0'
      viewBox='0 0 1000 1000'
    >
      <path
        fill='currentColor'
        d='M484.8 941.2l-48.5-84.1c-16.9-29.3-6.9-66.7 22.4-83.6l10.7-6.2c-.7-6.7-1-13.5-1-20.2s.3-13.4 1-20.2l-10.7-6.1c-14-8.1-24.3-21.6-28.5-37.2-4.2-15.7-2-32.4 6.1-46.5l48.5-84.1c8.1-14 21.6-24.3 37.2-28.5 5.2-1.4 10.5-2.1 15.9-2.1 10.7 0 21.3 2.8 30.6 8.2l10.8 6.2c11-7.5 22.7-14.1 34.8-19.8v-12.8c0-1 .6-1.9.6-2.9-32.4-24.6-73-43.7-125.4-53.8v-30.3c72.2-34.5 122.5-107.6 122.5-192.9C611.8 106 515.8 10 397.4 10s-214.3 96-214.3 214.4c0 85.4 50.3 158.5 122.5 192.9v30.3c-244.1 46.8-245 283.2-245 419.9 0 106.7 466.7 103.7 461.5 102.3a61.07 61.07 0 01-37.3-28.6z'
      />
      <path
        fill='currentColor'
        d='M899.1 747.1c0-18-3.2-35-7.8-51.6l48.1-27.7-48.6-84.1-47.5 27.4c-24.3-24.7-55.2-42.4-89.9-51.4v-55.4h-97.1v55.4c-34.6 9-65.6 26.6-89.9 51.4l-47.5-27.4-48.6 84.1 48.1 27.7c-4.5 16.6-7.8 33.6-7.8 51.6s3.2 35 7.8 51.6l-48.1 27.8 48.6 84.1 47.5-27.4c24.3 24.7 55.3 42.4 90 51.4V990l97.1-.1v-55.3c34.6-8.9 65.7-26.7 90-51.4l47.5 27.4 48.5-84.1-48-27.7c4.5-16.6 7.6-33.6 7.6-51.7zM704.9 864.4c-64.8 0-117.2-52.4-117.2-117.2 0-64.7 52.4-117.2 117.2-117.2s117.2 52.5 117.2 117.2-52.4 117.2-117.2 117.2z'
      />
    </svg>
  );
};

export default AdminIcon;
